var _line, _line2, _line3, _line4, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListOrdered(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "ql-stroke",
    x1: 7,
    x2: 15,
    y1: 4,
    y2: 4
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "ql-stroke",
    x1: 7,
    x2: 15,
    y1: 9,
    y2: 9
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "ql-stroke",
    x1: 7,
    x2: 15,
    y1: 14,
    y2: 14
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "ql-stroke ql-thin",
    x1: 2.5,
    x2: 4.5,
    y1: 5.5,
    y2: 5.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "ql-fill",
    d: "M3.5,6A0.5,0.5,0,0,1,3,5.5V3.085l-0.276.138A0.5,0.5,0,0,1,2.053,3c-0.124-.247-0.023-0.324.224-0.447l1-.5A0.5,0.5,0,0,1,4,2.5v3A0.5,0.5,0,0,1,3.5,6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "ql-stroke ql-thin",
    d: "M4.5,10.5h-2c0-.234,1.85-1.076,1.85-2.234A0.959,0.959,0,0,0,2.5,8.156"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "ql-stroke ql-thin",
    d: "M2.5,14.846a0.959,0.959,0,0,0,1.85-.109A0.7,0.7,0,0,0,3.75,14a0.688,0.688,0,0,0,.6-0.736,0.959,0.959,0,0,0-1.85-.109"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListOrdered);
export default __webpack_public_path__ + "static/media/list-ordered.3e184f964f06cafa0ae283d1ad5b6cd8.svg";
export { ForwardRef as ReactComponent };